import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withKeys as _withKeys, createSlots as _createSlots, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"white-space":"pre-wrap","margin-bottom":"1rem"} }

import {globalPromptStore} from "./global-prompt";
import {ref, watch} from "vue";
import {mdiEye, mdiEyeOff} from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalPrompt',
  setup(__props) {

const inputText = ref<string>("");
const enableShowHideUi = ref(false);

watch(() => globalPromptStore.shows, () => {
  if (!globalPromptStore.shows) {
    return;
  }
  // Initialize when "shows" updated
  inputText.value = "";
  enableShowHideUi.value = globalPromptStore.inputType === "password";
});

function cancel() {
  globalPromptStore.shows = false;
  globalPromptStore.resolveInput(undefined);
}

function ok() {
  globalPromptStore.shows = false;
  globalPromptStore.resolveInput(inputText.value);
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { justify: "center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_dialog, {
        modelValue: _unref(globalPromptStore).shows,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(globalPromptStore).shows) = $event)),
        persistent: "",
        width: _unref(globalPromptStore).width
      }, {
        default: _withCtx(() => [
          (_unref(globalPromptStore).shows)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h5" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(globalPromptStore).title), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("pre", _hoisted_1, _toDisplayString(_unref(globalPromptStore).message), 1),
                      _withDirectives(_createVNode(_component_v_text_field, {
                        modelValue: inputText.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputText).value = $event)),
                        onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (ok()), ["enter"])),
                        placeholder: _unref(globalPromptStore).placeholder,
                        type: _unref(globalPromptStore).inputType,
                        variant: "solo-filled",
                        autofocus: true
                      }, _createSlots({ _: 2 }, [
                        (enableShowHideUi.value)
                          ? {
                              name: "append-inner",
                              fn: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(globalPromptStore).inputType = _unref(globalPromptStore).inputType === 'text' ? 'password' : 'text')),
                                  icon: _unref(globalPromptStore).inputType === 'text' ? _unref(mdiEyeOff) : _unref(mdiEye),
                                  variant: "text"
                                }, null, 8, ["icon"])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["modelValue", "placeholder", "type"]), [
                        [_vShow, _unref(globalPromptStore).showsInput]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Cancel")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        color: "secondary",
                        variant: "text",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (ok()))
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("OK")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "width"])
    ]),
    _: 1
  }))
}
}

})